var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHammer = function SvgHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.376 119.5h11.247a1.888 1.888 0 0 0 1.294-.531c.343-.334.535-.785.535-1.254V38.302h-14.83v79.413c0 .473.194.927.542 1.262.348.335.82.523 1.31.523",
    fill: "#0D291C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.258 7.237V2c0-.197-.04-.392-.118-.574a1.495 1.495 0 0 0-.338-.487 1.563 1.563 0 0 0-.505-.325A1.609 1.609 0 0 0 55.701.5h-15.67C24.507.5 8.984 7.641 1.371 11.712a1.521 1.521 0 0 0-.674.722c-.135.306-.16.647-.073.968.088.322.284.606.558.809.274.202.61.311.955.31h19.774l10.876.143c.2 0 .398.038.583.113.184.074.352.183.492.32.14.138.25.3.325.48.075.179.111.37.108.563v15.616c0 .46.19.902.528 1.228a1.84 1.84 0 0 0 1.276.51h19.404a1.84 1.84 0 0 0 1.275-.51c.339-.326.529-.767.529-1.228V7.236h-.05Z",
    fill: "#647F7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.452 113.763h-14.83v4.428c-.001.343.139.672.389.917s.588.386.945.392h12.359c.356-.006.695-.147.945-.392.25-.245.39-.574.39-.917l-.198-4.428Z",
    fill: "#B06148"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.258 23.615h8.28c1.627 0 3.237.326 4.726.957a11.742 11.742 0 0 1 3.925 2.709l1.558 1.69H89.39a2.065 2.065 0 0 0 1.417-.58c.375-.366.585-.859.585-1.372V3.762c0-.514-.21-1.007-.585-1.372a2.066 2.066 0 0 0-1.417-.58H75.747L74.189 3.5a11.741 11.741 0 0 1-3.925 2.708c-1.49.631-3.099.957-4.726.958h-8.28v16.449Z",
    fill: "#647F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.564 33.422H37.41v4.19c0 .164.068.321.188.437.121.116.284.181.455.181h15.869c.17 0 .333-.065.454-.18a.607.607 0 0 0 .188-.438v-4.19Z",
    fill: "#B06148"
  })));
};

export default SvgHammer;